import { useEffect, useState } from "react";
import { City, HotelSearchParams, Itinerary } from "../../types";
import { generateHotelSearches } from "../../functions/ItineraryUtils";
import { Button } from "react-bootstrap";

interface Props {
    itinerary: Itinerary,
    cities: Record<string, City> | {},
}


const HotelSearchPanel: React.FC<Props> = ({ itinerary, cities }) => {

    const [hotelSearches, setHotelSearches] = useState<HotelSearchParams[] | []>([]);
    const [selectedSearch, setSelectedSearch] = useState<HotelSearchParams | null>(null);


    const generateBookingUrl = (data: HotelSearchParams) => {
        const { cityname } = data.location;
        const { checkin_date, checkout_date } = data;

        const baseUrl = 'https://www.booking.com/searchresults.html';
        const params = new URLSearchParams({
            ss: cityname,
            checkin: checkin_date,
            checkout: checkout_date,
            group_adults: '2',
            group_children: '0',
            no_rooms: '1',
        });

        return `${baseUrl}?${params.toString()}`;
    };


    useEffect(() => {
        if(itinerary.data.hotel_cities && itinerary.data.departure_date){
            const searches = generateHotelSearches(itinerary.data.hotel_cities, itinerary.data.departure_date, cities);
            setHotelSearches(searches);
        }

    }, []);

    return (
        <div>
            <div className="d-flex h-100">
              {/* Menu latéral */}
              <div className="" style={{ width: '250px' }}>
                <ul className="list-group">
                  {hotelSearches && hotelSearches.map((search) => (
                    <li
                      key={search.id}
                      className={`list-group-item list-group-item-action ${
                        selectedSearch?.id === search.id ? 'active' : ''
                      }`}
                      style={{ cursor: 'pointer' }}
                      onClick={() => setSelectedSearch(search)}
                    >
                      <b>{search.location.cityname}</b>
                      <br />
                      <small>{search.checkin_date} → {search.checkout_date}</small>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Zone principale */}
              <div className="flex-grow-1 p-4 pt-0 overflow-auto">

                {selectedSearch ? (
                  <div className="border rounded p-3 bg-white shadow-sm">
                    <h5>
                      Hotels à {selectedSearch.location.cityname}
                    </h5>
                    <p>Date d'arrivée : {selectedSearch.checkin_date}</p>
                    <p>Date de départ : {selectedSearch.checkout_date}</p>
                    {/* Ici, on imaginerait le composant qui déclenche une vraie recherche */}
                    <Button variant="primary" href={generateBookingUrl(selectedSearch)} target="_blank" rel="noopener noreferrer">
                    Rechercher sur Booking.com
                    </Button>
                  </div>
                ) : (
                  <p className="text-muted">Cliquez sur une recherche à gauche pour voir les résultats.</p>
                )}
              </div>
            </div>
        </div>
    )
};

export default HotelSearchPanel;